// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import type { DocumentFilter } from '@/types'

export const queryKeys = {
  // Auth
  auth: {
    session: () => ['auth', 'session'] as const,
    workspaces: () => ['auth', 'workspaces'] as const,
  },

  // Documents
  documents: {
    all: () => ['documents'] as const,
    list: (filter?: DocumentFilter) => ['documents', 'list', filter] as const,
    detail: (id: string) => ['documents', 'detail', id] as const,
    audit: (id: string) => ['documents', 'audit', id] as const,
  },

  // API Keys
  apiKeys: {
    all: () => ['apiKeys'] as const,
    list: () => ['apiKeys', 'list'] as const,
    detail: (id: string) => ['apiKeys', 'detail', id] as const,
  },

  // Billing
  billing: {
    all: () => ['billing'] as const,
    plan: () => ['billing', 'plan'] as const,
    subscription: () => ['billing', 'subscription'] as const,
    invoices: () => ['billing', 'invoices'] as const,
    usage: () => ['billing', 'usage'] as const,
    usageSeries: (days?: number) => ['billing', 'usageSeries', days] as const,
  },

  // Webhooks
  webhooks: {
    all: () => ['webhooks'] as const,
    list: () => ['webhooks', 'list'] as const,
    detail: (id: string) => ['webhooks', 'detail', id] as const,
    logs: (id: string) => ['webhooks', 'logs', id] as const,
  },

  // Audit Log
  auditLog: {
    all: () => ['auditLog'] as const,
    list: (filter?: Record<string, unknown>) => ['auditLog', 'list', filter] as const,
  },

  // Schema Registry
  schemas: {
    all: () => ['schemas'] as const,
    list: () => ['schemas', 'list'] as const,
    detail: (id: string) => ['schemas', 'detail', id] as const,
    diff: (from: string, to: string) => ['schemas', 'diff', from, to] as const,
  },

  // Account
  account: {
    organization: () => ['account', 'organization'] as const,
    profile:      () => ['account', 'profile'] as const,
    team:         () => ['account', 'team'] as const,
    invites:      () => ['account', 'invites'] as const,
    invitesMine:    () => ['account', 'invites', 'mine'] as const,
    sessions:     () => ['account', 'sessions'] as const,
    notificationPreferences: () => ['account', 'notificationPreferences'] as const,
    notifications:         () => ['account', 'notifications'] as const,
    notificationsUnread:   () => ['account', 'notifications', 'unread'] as const,
  },
} as const
